import { Component, Inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { LookupsService, LandingSiteContactDetails, Marker, EnvironmentService, BCASearch } from '@app/base/core';
import {DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SessionService } from '@app/base/core';
import { BuilderService } from '@app/modules/builder/base/services';
import { takeWhile } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'subdivision-request',
  templateUrl: './subdivision.request.component.html',
  styleUrls: ['./subdivision.request.component.css']
})
export class SubdivisionRequestComponent implements OnInit, OnDestroy {
  showGISMap = false;
  landingSiteContactDetails: LandingSiteContactDetails = new LandingSiteContactDetails();
  public mapTypeControl: any;
  public google: any;
  public latitude: number;
  public longitude: number;
  builderHomeForm: FormGroup;
  public zoom: number;
  public markerDraggable = false;
  public marker: Marker;
  public showMarker = false;
  public lat: number;
  date1 = new Date('04/09/2018');
  date2 = new Date('04/09/2019');
  public bcaDetailsSubscription: Subscription;
  public bcaSearch: BCASearch = {
    builderId: [],
    projectName: '',
    projectAddress: '',
    bcaStatus: '',
    subsidaryId: '',
    subsidarycompanyName: '',
    startDate: this.date1,
    endDate: this.date2,
    reqId: '',
    bcaStatusValue: ''
  };
  public long: number;
  public infoWindowOpen: boolean;
  public labelOptions: any;
  public propertyType: string;
  public mapTypeId: string;
  public errorMsg: string;
  public addressFromMarker: any;
  public showAddress = true;
  public gisMapUrl: SafeResourceUrl;
  public builderId: string[];
  public rowValue;
  public stateCd: string;
  public projectNumber: number;
  public projectName: string;
  public routeSubscription: any;
  public urlWithParameters: any;
  public killsubscribe: boolean;
  // imageURL: 'http://iconbug.com/download/size/128/icon/6329/small-home/';
  @ViewChild('infowindow', {static : false} )
  public infoWindow;
  constructor(
    // @Inject(Router) private router,
    // @Inject(MapsAPILoader) private mapsAPILoader: MapsAPILoader,
    public lookupSvc: LookupsService,
    public sanitizer: DomSanitizer,
    private sessionSvc: SessionService,
    public builderSvc: BuilderService,
    public environmentSvc: EnvironmentService,
    public route: ActivatedRoute
  ) {
    this.urlWithParameters = this.environmentSvc.gisURL;
  }
  ngOnInit() {
    this.killsubscribe = true;
    this.stateCd = this.sessionSvc.paramLdc;
    this.rowValue = this.route.snapshot.parent.params['id'];
    // To get project details
    this.sessionSvc.BcaData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
        if (success) {
         this.sessionSvc.GridData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
          this.projectNumber = success.projectNumber;
          this.projectName = success.projectName;
        });
      } else {
        this.sessionSvc.builderData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
         if (success) {
          this.builderId = success.BuilderId;
          for (let i = 0; i < this.builderId.length; i++) {
            this.bcaSearch.builderId.push(this.builderId[i]);
          }
        this.bcaSearch.reqId = this.rowValue;
        this.bcaDetailsSubscription = this.builderSvc.getBuilderBCADetails(this.bcaSearch).subscribe(result => {
          if (result.data[0].bcaId !== undefined) {
            this.projectNumber = result.data[0].bcaId;
          }
          this.projectName = result.data[0].projectName;
        });
      }
    });
  }
}); // To Show GIS map with subdivision location
    this.urlWithParameters += this.rowValue;
    this.urlWithParameters += '&state=' + this.stateCd;
    this.gisMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlWithParameters);
  }
  // ondestroy
  ngOnDestroy() {
    this.killsubscribe = false;
        if (this.bcaDetailsSubscription) {
           this.bcaDetailsSubscription.unsubscribe();
    }
  }


}
